document.addEventListener("DOMContentLoaded", (event) => {
  if(document.querySelectorAll('.footer_menuwrap h3')){
    document.querySelectorAll('.footer_menuwrap h3').forEach((ftrAccordion) => {
      ftrAccordion.addEventListener('click',function(){
        if(window.outerWidth < 992){
          if(ftrAccordion.closest('.footer_menuwrap').classList.contains("active")){
            ftrAccordion.closest('.footer_menuwrap').classList.remove("active");
            const content = ftrAccordion.closest('.footer_menuwrap').querySelector(".ftr-menu-wrap");
            content.style.maxHeight = null;
            
          }else{
            const ftrAccordionsWithIsOpen = document.querySelectorAll(".footer_menuwrap.active");
            ftrAccordionsWithIsOpen.forEach((ftrAccordionWithIsOpen) => {
              ftrAccordionWithIsOpen.classList.remove("active");
              const content = ftrAccordionWithIsOpen.querySelector(".ftr-menu-wrap");
              content.style.maxHeight = null;
            });
            ftrAccordion.closest('.footer_menuwrap').classList.add("active");
            const content = ftrAccordion.closest('.footer_menuwrap').querySelector(".ftr-menu-wrap");
            content.style.maxHeight = content.querySelector("ul").scrollHeight + "px";
          }
        }
      })
    })
  }
});